module.exports = __webpack_public_path__ + "static/media/icon_74.5309297f.svg";